"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingletonStrategy = void 0;
var SingletonStrategy;
(function (SingletonStrategy) {
    SingletonStrategy[SingletonStrategy["KeepEarliest"] = 1] = "KeepEarliest";
})(SingletonStrategy || (exports.SingletonStrategy = SingletonStrategy = {}));
